import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const roomsApi = createApi({
  reducerPath: 'Rooms',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['rooms'],
  endpoints: (builder) => ({
    // ---------------------- USERS ----------------------
    getAllRoomsList: builder.query({
      query: ({ page, keyword, visibility }) => {
        let url = `admin/rooms?pageno=${page}`;
        if (keyword) {
          url += `&search=${keyword}`;
        }
        if (visibility) {
          url += `&visibility=${visibility}`;
        }
        return {
          url: url,
          method: 'GET',
        };
      },
      transformResponse: (res) => res,
      providesTags: ['rooms'],
    }),

    getRoomById: builder.query({
      query: (id) => `admin/room/${id}`,
      providesTags: ['rooms'],
      transformResponse: (res) => res.body,
    }),
    deleteRoom: builder.mutation({
      query: (id) => ({
        url: `admin/room/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rooms'],
    }),

    disablePosting: builder.mutation({
        query: (id) => ({
          url: `admin/room/disable-posting/${id}`,
          method: 'PUT',
        }),
        invalidatesTags: ['rooms'],
      }),

    muteUser: builder.mutation({
        query: (data) => ({
          url: `admin/room/mute-user`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['rooms'],
    }),

    getRoomMedia: builder.query({
        query: ({id , pageno ,limit , type}) => `admin/room/media/${id}?pageno=${pageno}&limit=${limit}&type=${type}`,    
        transformResponse: (res) => res,
        providesTags: ['Users'], // Provides 'Trainer' tag for each individual trainer
       }),

    userRoomRequest: builder.mutation({
        query: (data) => ({
          url: `admin/room/member-request`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['rooms'],
    }),

    getRoomKnowledgeGraphData: builder.query({
      query: ({roomId}) => `room/knowledge-graph/${roomId}`,    
      transformResponse: (res) => res.body,
      providesTags: ['Users'], // Provides 'Trainer' tag for each individual trainer
     }),

     queryKnowledgeGraph: builder.mutation({
      query: ({ question, roomId }) => ({
        url: `knowledge-graph/query?roomId=${roomId}`,
        method: 'POST',
        body: { question },
      }),
      invalidatesTags: ['knowledgeGraph'],
    }),

    // Get graph stats (earliest / latest / count)
    getKnowledgeGraphStats: builder.query({
      query: ({ roomId }) => ({
        url: `knowledge-graph/stats?roomId=${roomId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.body,
      providesTags: ['knowledgeGraph'],
    }),

    // Get visual knowledge graph (nodes + edges)
    getKnowledgeGraphVisuals: builder.query({
      query: ({ roomId }) => ({
        url: `knowledge-graph/graph-visuals?roomId=${roomId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.body,
      providesTags: ['knowledgeGraph'],
    }),

  }),
});

export const { useGetAllRoomsListQuery , useDeleteRoomMutation  , useDisablePostingMutation , useGetRoomByIdQuery ,useGetRoomMediaQuery , useMuteUserMutation , useUserRoomRequestMutation , useGetRoomKnowledgeGraphDataQuery 
  , useGetKnowledgeGraphStatsQuery , useGetKnowledgeGraphVisualsQuery , useQueryKnowledgeGraphMutation} = roomsApi;
